import Vue from 'vue'
import Vuex from 'vuex'
import {
  createProxy,
  extractVuexModule,
} from 'vuex-class-component';
import { AccountsStore } from '@/store/theoryApiStore/accounts.store';
import { ProjectsStore } from '@/store/theoryApiStore/projects.store';
import { ProjectMembersStore } from '@/store/theoryApiStore/projectMembers.store';
import { TasksStore } from '@/store/theoryApiStore/tasks.store';
import { AuthStore } from '@/store/theoryApiStore/auth.store';
import { MastersStore } from '@/store/theoryApiStore/masters.store';
import { OrganizationsStore } from '@/store/theoryApiStore/organizations.store';
import { ActivitiesStore } from '@/store/theoryApiStore/activities.store';
import { NotificationsStore } from '@/store//theoryApiStore/notifications.store';
import { DirectoriesStore } from '@/store/theoryApiStore/directories.store';
import { FilesStore } from '@/store/theoryApiStore/files.store';
import { BranchesStore } from './theoryGitStore/branches.store';
import { FilesStore as GitFilesStore } from './theoryGitStore/files.store';
import { LogsStore } from './theoryGitStore/logs.store';
import { RepositoryInfoStore } from './theoryGitStore/repositoryInfo.store';
import { TagsStore } from './theoryGitStore/tags.store';

Vue.use(Vuex)

const store =  new Vuex.Store({
  modules: {
    ...extractVuexModule(AccountsStore),
    ...extractVuexModule(ProjectsStore),
    ...extractVuexModule(ProjectMembersStore),
    ...extractVuexModule(TasksStore),
    ...extractVuexModule(AuthStore),
    ...extractVuexModule(MastersStore),
    ...extractVuexModule(OrganizationsStore),
    ...extractVuexModule(ActivitiesStore),
    ...extractVuexModule(NotificationsStore),
    ...extractVuexModule(DirectoriesStore),
    ...extractVuexModule(FilesStore),
    ...extractVuexModule(BranchesStore),
    ...extractVuexModule(GitFilesStore),
    ...extractVuexModule(LogsStore),
    ...extractVuexModule(RepositoryInfoStore),
    ...extractVuexModule(TagsStore),
  },
});

export default store;

export const vxm = {
  theoryApi: {
    accountsStore: createProxy(store, AccountsStore),
    projectsStore: createProxy(store, ProjectsStore),
    projectMembersStore: createProxy(store, ProjectMembersStore),
    tasksStore: createProxy(store, TasksStore),
    authStore: createProxy(store, AuthStore),
    mastersStore: createProxy(store, MastersStore),
    organizationsStore: createProxy(store, OrganizationsStore),
    activitiesStore: createProxy(store, ActivitiesStore),
    notificationsStore: createProxy(store, NotificationsStore),
    directoriesStore: createProxy(store, DirectoriesStore),
    filesStore: createProxy(store, FilesStore),
  },
  theoryGit: {
    branchesStore: createProxy(store, BranchesStore),
    filesStore: createProxy(store, GitFilesStore),
    logsStore: createProxy(store, LogsStore),
    repositoryInfoStore: createProxy(store, RepositoryInfoStore),
    tagsStore: createProxy(store, TagsStore),
  },
};
